/**
 * Что платформа вообще позволяет делать со звуком. Общее для звонка 1:1 и группового голоса:
 * оба показывают одни и те же настройки и обязаны одинаково молчать там, где настройка ничего
 * не изменит.
 */

/**
 * iOS требует отдельной ветки для нативных маршрутов, микрофона и системной громкости.
 * Выход в Safari проверяется отдельно через setSinkId и список audiooutput: новые версии
 * WebKit могут отдавать управляемые выходы. iPadOS притворяется MacIntel, отсюда тач-точки.
 */
export const IS_IOS_AUDIO_ROUTED =
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

/** Выбор динамика есть только там, где браузер умеет `setSinkId`. */
export const SPEAKER_SELECTION_SUPPORTED =
  typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype;

/**
 * Громкость `<audio>` меняется только на десктопе: на iOS свойство `volume` доступно лишь на
 * чтение, на Android громкостью медиа распоряжается система. Поэтому «сделать тише» там показывать
 * нельзя — ползунок двигался бы, а звук нет. «Заглушить» работает везде: это отдельный флаг
 * `muted`, а не громкость.
 */
export const ELEMENT_VOLUME_SUPPORTED =
  typeof navigator !== 'undefined' &&
  !IS_IOS_AUDIO_ROUTED &&
  !/Android/.test(navigator.userAgent);
